import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { Layout } from "..";
import { Container } from "./styled";
import { SharePopup as SharePupupComponent } from "../../components";
import secureLocalStorage from "react-secure-storage";
import { addModal } from "../../lib/addModal";

function BoardCollection() {
  const [isShare, setIsShare] = useState(false);
  const [sharedData, setSharedData] = useState({
    emails: [],
    inputValue: null,
  });
  const userId = secureLocalStorage.getItem("userId");
  const location = useLocation();
  const sessionUser = sessionStorage.getItem("user");
  const collectionProps = location.state.collection;

  function getClipDataById(clipId) {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) return null;

    const ownClips = user.analyticsClips
      ? Object.values(user.analyticsClips)
      : [];
    const foundOwnClip = ownClips.find((clip) => clip.id === clipId);

    if (foundOwnClip) return { ...foundOwnClip, type: "own" };

    const sharedClips = user.sharedClips || [];
    const foundSharedClip = sharedClips.find((clip) => clip.id === clipId);

    if (foundSharedClip) return { ...foundSharedClip, type: "shared" };

    return null;
  }

  function makeCollectionSlug(senderId, clipId, templateId) {
    return `CO-${senderId}__${clipId}__${templateId}`;
  }

  async function handleShareCollection() {
    const slug = makeCollectionSlug(userId, collectionProps.id);
    let user = JSON.parse(sessionUser) || {};
    let userBKP = user;

    const existingAccounts = userBKP.relatedAccounts || [];

    const newAccounts = sharedData.emails.filter(
      (email) => !existingAccounts.includes(email)
    );

    if (newAccounts.length > 0) {
      const updatedAccounts = [...existingAccounts, ...newAccounts];
      userBKP.relatedAccounts = updatedAccounts;

      await sessionStorage.setItem("user", JSON.stringify(userBKP));
      secureLocalStorage.setItem("user", userBKP);
      secureLocalStorage.setItem("userLocal", userBKP);
    }

    try {
      const res = await fetch(
        "https://deportactico-vercel-serverless.vercel.app/api/shareClip",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fromName: user.name,
            senderId: userId,
            toEmails: sharedData.emails,
            clipName: collectionProps.name,
            shareLink: `https://deportacticoapp.vercel.app/app/SharedBoard/${slug}`,
          }),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || "Error compartiendo el clip");
      }

      setIsShare(false);
      addModal({ modal: "SuccessModal", linkTo: `` });
    } catch (err) {
      console.error("❌ Error fetching shared clip:", err);
      addModal({ modal: "ErrorModal", linkTo: `` });
    }
  }

  const handleSend = async () => {
    if (sharedData.emails.length === 0)
      return alert("Agrega al menos un correo válido.");
    await handleShareCollection();
    setIsShare(false);
  };

  return (
    <Layout>
      <Container>
        <h1>{collectionProps?.name}</h1>
        <button
          className="btn-primary ghost no-print"
          onClick={(e) => {
            setIsShare(true);
          }}
        >
          Compartir
        </button>
        <SharePupupComponent
          isActive={isShare}
          popupStep={"isShare"}
          setIsShare={setIsShare}
          onChange={(data) => {
            setSharedData(data);
          }}
          onSend={() => {
            handleSend();
          }}
          isCollection={true}
        />

        <div className="boards-container">
          {collectionProps.clipIds?.map((clip) => {
            const isIdOnly = typeof clip === "string";

            const clipData = isIdOnly ? getClipDataById(clip) : clip;

            if (!clipData)
              return (
                <div
                  key={isIdOnly ? clip : clip.id}
                  className="clip-card missing"
                >
                  <p>Clip no encontrado (ID: {isIdOnly ? clip : clip.id})</p>
                </div>
              );

            return (
              <div key={clipData.id} className="board-card">
                <h3 className="title">{clipData.name}</h3>
                <Link
                  className="btn-primary"
                  to={`/app/analytics/C-${clipData.id}`}
                >
                  Ver
                </Link>
              </div>
            );
          })}
        </div>
      </Container>
    </Layout>
  );
}

export default BoardCollection;
